import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "footer-menu",
  "aria-label": "Navigation principale"
}
const _hoisted_2 = ["aria-current", "aria-label"]
const _hoisted_3 = { class: "footer-menu-label" }
const _hoisted_4 = {
  key: 1,
  class: "footer-menu-item footer-placeholder",
  disabled: "",
  "aria-hidden": "true",
  tabindex: "-1"
}
const _hoisted_5 = ["aria-current", "aria-label"]
const _hoisted_6 = { class: "footer-menu-label" }
const _hoisted_7 = {
  key: 3,
  class: "footer-menu-item footer-placeholder",
  disabled: "",
  "aria-hidden": "true",
  tabindex: "-1"
}
const _hoisted_8 = ["aria-current", "aria-label"]
const _hoisted_9 = { class: "footer-menu-label" }
const _hoisted_10 = ["aria-current", "aria-label"]
const _hoisted_11 = { class: "footer-menu-label" }
const _hoisted_12 = ["aria-current", "aria-label"]
const _hoisted_13 = { class: "footer-menu-label" }
const _hoisted_14 = {
  key: 7,
  class: "footer-menu-item footer-placeholder",
  disabled: "",
  "aria-hidden": "true",
  tabindex: "-1"
}
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { class: "footer-menu-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createBlock(_component_ion_footer, { class: "site-manager-footer" }, {
    default: _withCtx(() => [
      _createElementVNode("nav", _hoisted_1, [
        (_ctx.isValidated)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: _normalizeClass(["footer-menu-item", { 'is-selected': _ctx.isUnderPath('/site-manager/quotation-requests') }]),
              "aria-current": _ctx.isUnderPath('/site-manager/quotation-requests') ? 'page' : undefined,
              "aria-label": _ctx.t('tabs.quotations'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('SiteManagerQuotationRequests')))
            }, [
              _createVNode(_component_ion_icon, {
                icon: _ctx.pricetagOutline,
                class: "footer-menu-icon"
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('tabs.quotations')), 1)
            ], 10, _hoisted_2))
          : (_openBlock(), _createElementBlock("button", _hoisted_4)),
        (_ctx.isValidated)
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: _normalizeClass(["footer-menu-item", { 'is-selected': _ctx.isUnderPath('/site-manager/orders', '/site-manager/delivery-request', '/site-manager/delivery-notes') }]),
              "aria-current": _ctx.isUnderPath('/site-manager/orders', '/site-manager/delivery-request', '/site-manager/delivery-notes') ? 'page' : undefined,
              "aria-label": _ctx.t('tabs.orders'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('SiteManagerOrders')))
            }, [
              _createVNode(_component_ion_icon, {
                icon: _ctx.clipboardOutline,
                class: "footer-menu-icon"
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('tabs.orders')), 1)
            ], 10, _hoisted_5))
          : (_openBlock(), _createElementBlock("button", _hoisted_7)),
        (_ctx.isValidated)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              type: "button",
              class: _normalizeClass(["footer-menu-item tab-home", { 'is-selected': _ctx.isActive('SiteManagerDashboard') }]),
              "aria-current": _ctx.isActive('SiteManagerDashboard') ? 'page' : undefined,
              "aria-label": _ctx.t('tabs.dashboard'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('SiteManagerDashboard')))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["home-bubble", { 'home-bubble-active': _ctx.isActive('SiteManagerDashboard') }])
              }, [
                _createVNode(_component_ion_icon, {
                  icon: _ctx.homeOutline,
                  class: "footer-menu-icon"
                }, null, 8, ["icon"])
              ], 2),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.t('tabs.dashboard')), 1)
            ], 10, _hoisted_8))
          : (_openBlock(), _createElementBlock("button", {
              key: 5,
              type: "button",
              class: _normalizeClass(["footer-menu-item", { 'is-selected': _ctx.isActive(_ctx.SiteManagerDeliveryCallsRoute) }]),
              "aria-current": _ctx.isActive(_ctx.SiteManagerDeliveryCallsRoute) ? 'page' : undefined,
              "aria-label": _ctx.t('tabs.planning'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo(_ctx.SiteManagerDeliveryCallsRoute)))
            }, [
              _createVNode(_component_ion_icon, {
                icon: _ctx.calendarOutline,
                class: "footer-menu-icon"
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t('tabs.planning')), 1)
            ], 10, _hoisted_10)),
        (_ctx.isValidated)
          ? (_openBlock(), _createElementBlock("button", {
              key: 6,
              type: "button",
              class: _normalizeClass(["footer-menu-item", { 'is-selected': _ctx.isActive(_ctx.SiteManagerDeliveryCallsRoute) }]),
              "aria-current": _ctx.isActive(_ctx.SiteManagerDeliveryCallsRoute) ? 'page' : undefined,
              "aria-label": _ctx.t('tabs.planning'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo(_ctx.SiteManagerDeliveryCallsRoute)))
            }, [
              _createVNode(_component_ion_icon, {
                icon: _ctx.calendarOutline,
                class: "footer-menu-icon"
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('tabs.planning')), 1)
            ], 10, _hoisted_12))
          : (_openBlock(), _createElementBlock("button", _hoisted_14)),
        _createElementVNode("button", {
          type: "button",
          class: "footer-menu-item",
          "aria-label": _ctx.t('tabs.more'),
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openMoreSheet && _ctx.openMoreSheet(...args)))
        }, [
          _createVNode(_component_ion_icon, {
            icon: _ctx.menuOutline,
            class: "footer-menu-icon"
          }, null, 8, ["icon"]),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('tabs.more')), 1)
        ], 8, _hoisted_15)
      ])
    ]),
    _: 1
  }))
}